const MAX_ABBREVIATION_LENGTH = 3;

export const isPersonalAccount = (name: string, userEmail?: string) =>
  userEmail && name.includes(userEmail);

export const getAccountLabel = (name: string, userEmail?: string) => {
  if (isPersonalAccount(name, userEmail)) {
    return 'My Workspace';
  }

  return name;
};

export const getAccountAbbreviation = (
  name: string,
  userEmail?: string,
): string => {
  if (isPersonalAccount(name, userEmail)) {
    return 'MW';
  }
  if (name === 'PLATFORM') {
    return 'PLT';
  }
  if (name === 'PolyAIDemos') {
    return 'DMO';
  }

  const finalName = name.includes('@poly') ? name.split('@')[0] : name;

  const getInitials = (pattern: RegExp) =>
    (finalName.match(pattern) ?? [])
      .slice(0, MAX_ABBREVIATION_LENGTH)
      .join('')
      .toUpperCase();

  const wordInitials = getInitials(/\b[A-Za-z]/g);
  if (wordInitials.length >= 2) {
    return wordInitials;
  }

  const capitalLetters = getInitials(/\b[A-Za-z]|\B[A-Z]/g);
  if (capitalLetters.length >= 2) {
    return capitalLetters;
  }

  const consonants = getInitials(/^[a-zA-Z]|[^aeiouAEIOU]/g);

  if (consonants.length >= 2) {
    return consonants;
  }

  return finalName.slice(0, MAX_ABBREVIATION_LENGTH).toUpperCase();
};
